import { SET_QUOTA_EXCEEDED, SET_TRIAL_EXPIRED } from '../action-types';

export const setQuotaExceeded = () =>
  <const>{
    type: SET_QUOTA_EXCEEDED,
  };

export const setTrialExpired = () =>
  <const>{
    type: SET_TRIAL_EXPIRED,
  };

export type UserActions = ReturnType<
  typeof setQuotaExceeded | typeof setTrialExpired
>;
